import React, {Component} from 'react';
import EventsList from '../../components/EventsList';
import { logError, fromDynamoJson, updateInPath } from '../../../common/utils/';
import { API } from 'aws-amplify';

class Events extends Component {
  constructor(props) {
    super();
    this.state = { data: [] };
  }

  eventsReducer = (acc, e) => {
    const beginTs = (new Date(e.beginDate)).getTime(),
          endTs = (new Date(e.endDate)).getTime(),
          now = (new Date()).getTime();

    let ix = 2; // future

    if (endTs && endTs < now) {
      ix = 0; // past
    } else if (beginTs < now && endTs > now) {
      ix = 1; //present
    }

    acc[ix].push(e);
    return acc;
  };

  fetchData = () => {
    API.get('RobotexPublicAPI', '/v1/events/', {})
      .then(({ Items }) => {
        const converted = Items.map(fromDynamoJson);
        const segmented = converted.reduce(this.eventsReducer, [[], [], []]);
        this.setState(prevState => updateInPath(prevState, 'data', segmented));
      })
      .catch(logError);
  }

  componentWillMount() {
    document.body.style.backgroundImage = 'url("bg.jpg")';
  }

  componentWillUnmount() {
    document.body.style.backgroundImage = '';
  }


  componentDidMount() {
    this.fetchData();
  }
  
  render() {
    const [past, present, future] = this.state.data;

    return (
      <EventsList
        past={past}
        present={present}
        future={future}
      />
    );
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/public/containers/Events/index.js